import React from 'react'

export function ListAltIcon(stroke?: string) {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.10817 15.119H17.2272M7.10817 10.0595H17.2272M7.10817 5H17.2272M3.06252 15.119V15.1211L3.06055 15.1211V15.119H3.06252ZM3.06252 10.0595V10.0615L3.06055 10.0616V10.0595H3.06252ZM3.06252 5V5.00202L3.06055 5.00204V5H3.06252Z"
                stroke={stroke || 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
